import { createActions } from '@manager-base/app-base/config/data-access';
import { BASE_PATH_API } from '@manager-base/app-base/environment/paths/constants';

const actions = {
    getTaskById: {
        method: 'GET',
        url: `${BASE_PATH_API}/v3/tasks/:id`
    },
    getAll: {
        method: 'GET',
        url: `${BASE_PATH_API}/v3/tasks`,
        params: {
            '$count': true,
            'includeCoverImages': true
        }
    },
    getAllV4: {
        method: 'GET',
        url: `${BASE_PATH_API}/v4/tasks`,
        params: {
            '$count': true,
            'includeCoverImages': true
        }
    },
    updateTask: {
        method: 'PUT',
        url: `${BASE_PATH_API}/v3/tasks/:id`
    },
    deleteTask: {
        method: 'DELETE',
        url: `${BASE_PATH_API}/v3/tasks/:id`
    },
    getTaskEvents: {
        method: 'GET',
        url: `${BASE_PATH_API}/tasks/:id/events`,
        isArray: true
    },
    getTaskCategories: {
        method: 'GET',
        url: `${BASE_PATH_API}/tasks/categories`
    },
    getTaskCategoryOptions: {
        method: 'GET',
        url: `${BASE_PATH_API}/tasks/categoryOptions`
    },
    getContactRequestInfo: {
        method: 'GET',
        url: `${BASE_PATH_API}/v3/tasks/:id/contactRequestInfo`
    },
    updateContactRequestInfo: {
        method: 'PUT',
        url: `${BASE_PATH_API}/v3/tasks/:id/contactRequestInfo`
    },
    getWorkOrderById: {
        method: 'GET',
        url: `${BASE_PATH_API}/v3/workOrders/:id`
    },
    getWorkOrderDetailsByWorkOrderId: {
        method: 'GET',
        url: `${BASE_PATH_API}/v3/workOrderDetails?workOrderid=:workOrderId`
    },
    getWorkOrderCount: {
        method: 'HEAD',
        url: `${BASE_PATH_API}/v3/workOrders`,
        transformResponse: function transform(data, headers) {
            return parseInt(headers.get('X-Buildium-Workorders-Count'), 10);
        }
    },
    deleteWorkOrderById: {
        method: 'DELETE',
        url: `${BASE_PATH_API}/v3/workOrders/:id`
    },
    getWorkOrderAppliancesByBuildingId: {
        method: 'GET',
        url: `${BASE_PATH_API}/workOrders/appliancesByBuilding/:buildingId`,
        isArray: true
    },
    getStaffMembers: {
        method: 'GET',
        url: `${BASE_PATH_API}/v3/tasks/staffMembers`
    },
    getStaffMembersForBulkUpdate: {
        method: 'GET',
        url: `${BASE_PATH_API}/v3/tasks/bulk/staffMembers`
    },
    emailWorkOrder: {
        method: 'POST',
        url: `${BASE_PATH_API}/workOrders/:workOrderId/emailVendor`
    },
    getEntryContactDetails: {
        method: 'GET',
        url: `${BASE_PATH_API}/workOrders/:workOrderId/entryContact`
    },
    getTaskResidents: {
        method: 'GET',
        url: `${BASE_PATH_API}/v3/tasks/:id/residents`,
        isArray: true
    },
    getTaskResidentsByUserLeaseId: {
        method: 'GET',
        url: `${BASE_PATH_API}/v3/tasks/residentsByUserLease/:leaseId`,
        isArray: true
    },
    getPropertyImages: {
        method: 'GET',
        url: `${BASE_PATH_API}/v3/tasks/:id/propertyImages/:propertyId`
    },
    getTaskProperties: {
        method: 'GET',
        url: `${BASE_PATH_API}/v3/tasks/properties`,
        isArray: true
    },
    getWorkOrderVendor: {
        method: 'GET',
        url: `${BASE_PATH_API}/v3/workOrders/:workOrderId/vendors/:vendorId`
    },
    updateTasksInBulk: {
        method: 'PUT',
        url: `${BASE_PATH_API}/v3/tasks/bulk`
    },
    addTask: {
        method: 'POST',
        url: `${BASE_PATH_API}/v4/tasks`
    },
    getTaskSubcategories: {
        method: 'GET',
        url: `${BASE_PATH_API}/taskSubcategories`
    },
    getAllResidents: {
        method: 'GET',
        url: `${BASE_PATH_API}/tasks/residents`,
        isArray: true
    },
    getAllRentalOwners: {
        method: 'GET',
        url: `${BASE_PATH_API}/tasks/rentalOwners`,
        isArray: true
    },
    getRentalOwnersByTaskId: {
        method: 'GET',
        url: `${BASE_PATH_API}/v3/tasks/:taskId/rentalOwners`,
        isArray: true
    },
    getBoardMembersByTaskId: {
        method: 'GET',
        url: `${BASE_PATH_API}/v3/tasks/:taskId/boardMembers`,
        isArray: true
    },
    getWorkOrders: {
        method: 'GET',
        url: `${BASE_PATH_API}/workorders`,
        params: {
            '$count': true
        }
    },
    getWorkOrdersV3: {
        method: 'GET',
        url: `${BASE_PATH_API}/v3/workorders`
    },
    getEntryContacts: {
        method: 'GET',
        url: `${BASE_PATH_API}/workorders/entryContacts`,
        isArray: true
    },
    addWorkOrder: {
        method: 'PUT',
        url: `${BASE_PATH_API}/tasks/:taskId/workOrder`
    },
    updateWorkOrder: {
        method: 'PUT',
        url: `${BASE_PATH_API}/workOrders/:workOrderId`
    },
    getRentalOwnerRequests: {
        method: 'GET',
        url: `${BASE_PATH_API}/tasks/rentalOwnerRequests`,
        params: {
            '$count': true
        }
    },
    getEventsForRentalOwnerRequests: {
        method: 'GET',
        url: `${BASE_PATH_API}/tasks/:taskId/rentalOwnerRequests/events`,
        isArray: true
    },
    getTaskForRentalOwnerRequests: {
        method: 'GET',
        url: `${BASE_PATH_API}/tasks/:taskId/rentalOwnerRequests`
    },
    getRentalOwnerRequestProperties: {
        method: 'GET',
        url: `${BASE_PATH_API}/tasks/rentalOwnerRequests/properties`
    },
    getStaffMemberAssignees: {
        method: 'GET',
        url: `${BASE_PATH_API}/v3/tasks/staffMemberAssignees`,
        isArray: true
    },
    getStaffMembersAssigneesByTaskId: {
        method: 'GET',
        url: `${BASE_PATH_API}/v3/tasks/:taskId/staffMemberAssignees`,
        isArray: true
    },
    getStaffMembersAssigneesByBuildingId: {
        method: 'GET',
        url: `${BASE_PATH_API}/v3/tasks/staffMemberAssigneesForBuilding/:buildingId`,
        isArray: true
    },
    getAppliancesByBuildingId: {
        method: 'GET',
        url: `${BASE_PATH_API}/v3/tasks/appliancesByBuilding/:buildingId`,
        isArray: true
    },
    getRentalOwnerNamesByBuildingId: {
        method: 'GET',
        url: `${BASE_PATH_API}/v3/tasks/rentalOwnersForBuilding/:buildingId`,
        isArray: true
    },
    getUserForTask: {
        method: 'GET',
        url: `${BASE_PATH_API}/v3/tasks/:id/user/:userId`,
    },
    sendManualContributionRequestReminder: {
        method: 'POST',
        url: `${BASE_PATH_API}/tasks/:taskId/contributionRequests/manualReminder`
    },
    sendBulkContributionRequestReminders: {
        method: 'POST',
        url: `${BASE_PATH_API}/tasks/bulk/contributionRequests/manualReminders`
    },
    getAllAttachments: {
        method: 'GET',
        url: `${BASE_PATH_API}/v3/tasks/:id/attachments`,
    },
    getCompleteTaskOnPayment: {
        method: 'GET',
        url: `${BASE_PATH_API}/tasks/contributionRequests/completeTask`
    },
    setCompleteTaskOnPayment: {
        method: 'PUT',
        url: `${BASE_PATH_API}/tasks/contributionRequests/complete/:completeTask`
    },
    getRentalOwnerContributionRequestTasksForRentalOwner: {
        method: 'GET',
        url: `${BASE_PATH_API}/tasks/rentalOwnerContributionRequests`,
    },
    GetContributionRequestPropertyEpaySettings: {
        method: 'GET',
        url: `${BASE_PATH_API}/tasks/rentalOwnerContributionRequests/property/:propertyId/epaySettings`,
    },
    getTaskSettings: {
        method: 'GET',
        url: `${BASE_PATH_API}/taskSettings`,
    },
    createWorkOrder: {
        method: 'POST',
        url: `${BASE_PATH_API}/v3/workOrders/`
    },
    updateWorkOrderV3: {
        method: 'PUT',
        url: `${BASE_PATH_API}/v3/workOrders/:workOrderId`
    },
    getWorkOrderBillsV3: {
        method: 'GET',
        url: `${BASE_PATH_API}/v3/workOrders/:id/bills`,
    },
    getAllTaskActivities: {
        method: 'GET',
        url: `${BASE_PATH_API}/v3/tasks/:taskId/activities`,
    },
    getTaskRelationships: {
        method: 'GET',
        url: `${BASE_PATH_API}/taskRelationships?taskId=:taskId`,
    },
    createTaskRelationship: {
        method: 'POST',
        url: `${BASE_PATH_API}/taskRelationships`
    },
    updateTaskRelationship: {
        method: 'PUT',
        url: `${BASE_PATH_API}/taskRelationships/:taskRelationshipId`
    },
    deleteTaskRelationship: {
        method: 'DELETE',
        url: `${BASE_PATH_API}/taskRelationships/:taskRelationshipId`
    },
    getWorkOrderRelationships: {
        method: 'GET',
        url: `${BASE_PATH_API}/workOrderRelationships?workOrderId=:workOrderId`
    },
    createWorkOrderRelationship: {
        method: 'POST',
        url: `${BASE_PATH_API}/workOrderRelationships`
    },
    updateWorkOrderRelationship: {
        method: 'PUT',
        url: `${BASE_PATH_API}/workOrderRelationships/:workOrderRelationshipId`
    },
    deleteWorkOrderRelationship: {
        method: 'DELETE',
        url: `${BASE_PATH_API}/workOrderRelationships/:workOrderRelationshipId`
    }
};

export function TasksApi(
    $httpParamSerializer
) {
    const service = createActions(actions);

    service.printWorkOrder = function printWorkOrder(params) {
        return `${BASE_PATH_API}/workorders/print?${$httpParamSerializer(params)}`;
    };

    service.getWorkOrdersExportUrl = function getWorkOrdersExportUrl(params) {
        return `${BASE_PATH_API}/workorders/export?${$httpParamSerializer(params)}`;
    };

    service.printTask = function printTask(params, taskId) {
        return `${BASE_PATH_API}/v3/tasks/${taskId}/print?${$httpParamSerializer(params)}`;
    };

    service.printTaskForRentalOwnerRequest = function printTaskForRentalOwnerRequest(params, taskId) {
        return `${BASE_PATH_API}/tasks/${taskId}/rentalOwnerRequests/print?${$httpParamSerializer(params)}`;
    };

    service.getTasksExportUrl = function getTasksExportUrl(queryString) {
        return `${BASE_PATH_API}/v3/tasks/export${queryString}`;
    };

    service.getTasksByProjectExportUrl = function getTasksByProjectExportUrl(params) {
        return `${BASE_PATH_API}/v3/tasks/export?${$httpParamSerializer(params)}`;
    };
    return service;
}
TasksApi.$inject = [
    '$httpParamSerializer'
];
